import React from "react"

import * as styles from "./aligned-block.module.css"

const AlignedBlock = ({ align, children }) => (
  <div className={`${styles.wrapper} ${styles[align]}`}>{children}</div>
)

export default AlignedBlock
